<template>
    <div>
	  <div class="page-filter-box MT10">		  
		  <el-row :gutter="20">
			  <el-col :span="6">
				  <el-date-picker
				        v-model="params.year"
				        type="year"
						size="small"
						value-format="yyyy"
						style="width: 100%;"
				        placeholder="选择年份">
				      </el-date-picker>
			  </el-col>
			  <el-col :span="10">
				  <el-date-picker
					  v-model="datetimerange"
					  type="daterange"
					  range-separator="-"
					  start-placeholder="日期"
					  end-placeholder="日期"
					  size="small"
					  value-format="yyyy-MM-dd"
					  :clearable="false"
					  style="width:100%"
					  unlink-panels
					  >
				  </el-date-picker>
			  </el-col>
			  <el-col :span="8" class="page-filter-btns">
				  <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
				  <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				  <el-button v-if="$utils.have('/lpa/statistics/export')" type="primary" icon="el-icon-download" size="small"
				      @click="download" :loading="downLoading">导出</el-button>
			  </el-col>
		  </el-row>
	  </div>      
        <div class="page-list-box">
			<el-card  shadow="never" class="statistics-box" v-if="data">
			    <el-row :gutter="20">
			        <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{data.totalNum || 0}}</p><p class="color-info">投票数</p></el-col>
			        <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{data.totalUser || 0}}</p><p class="color-info">投票人数</p></el-col>		          
			    </el-row>
			</el-card>
            <el-table :data="dataList" border style="width: 100%" v-loading="dataLoading" size="small" stripe>
                <el-table-column label="序号" prop="intKey"></el-table-column>
                <el-table-column label="事件名" prop="strKey2" min-width="160"></el-table-column>                
                <el-table-column label="pv" prop="longKey"></el-table-column>
                <el-table-column label="uv" prop="count"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi';
const defaultParams = {
    start:'',
	end:'',
	year:'2026'
}
export default {
    components: {  },
    data() {
        return {
            dataLoading: false,
            dataList: null,
            data: null,
            params: {
                ...defaultParams,                
            },
			downLoading:false,
			datetimerange: [this.$route.query.start || '', this.$route.query.end || ''],
        }
    },
    mounted() {
        this.getDataList()
    },
    methods: {
        //获取列表
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: "/lpa/statistics",
                method: "POST",
                data: {
                    ...this.params,
					start: this.datetimerange[0] || null,
					end: this.datetimerange[1] || null,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.dataList || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },       
        //搜索
        search() {            
            this.getDataList();
        }, 
		//重置搜索
		reset() {
		    this.datetimerange = [];
		    this.params = {
		        ...defaultParams
		    };
		    this.getDataList();
		},
		//导出
		async download(){
		    let filePath;
		    this.downLoading = true;
		    const res = await this.$request({
		        url:'/lpa/statistics/export',
		        method: 'post',
		        data: {
		            ...this.params,
					start: this.datetimerange[0] || null,
					end: this.datetimerange[1] || null,		           
		        },
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result){
		        filePath = result.url;
		    }else{
		        this.downLoading = false;
		        return this.$message.error(msg || '下载失败');
		    }   
		
		    await downloadFileTmp(filePath,'LPA投票数据.'+this.$utils.getFileType(filePath));
		    this.downLoading = false;
		}       

    },

}
</script>
<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 18px;
            margin-bottom: 5px;
			font-weight: bold;
        }
    }
}
</style>